import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunriseArrowUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSunriseArrowUp"><Path d="M2.75391 20.2499H21.2539M12 8.24988V2.99988M2.75 16.2499H4.25M19.75 16.2499H21.25M9.5 5.25488L12 2.75488L14.5 5.25488M7.75 16.2499V15.9999C7.75 13.6527 9.65279 11.7499 12 11.7499C14.3472 11.7499 16.25 13.6527 16.25 15.9999V16.2499M17.9375 11.0183L19.0866 10.0541M4.91406 10.0541L6.06313 11.0183" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSunriseArrowUp;
